import styled from "styled-components";

export const StyledNavItem = styled.span`
  & sup {
    font-size: ${(props) => props.theme.font.size.xs};
    vertical-align: super;
  }
`;
